// Mock fridge / pickup locations (fallback when API is down)
export const FRIDGES = [
  { id: 'f1', name: 'Metio — Salle de convivialité (C 04-012)', address: 'Route de la Corniche 2, 1066 Épalinges', hours: '24h/24 · 7j/7', lat: 46.5417, lng: 6.6648,
    floor: 'Niveau -1', access_code: '',
    instructions: {
      fr: 'Entrez dans le bâtiment Metio et descendez au niveau -1. Au -1, dirigez-vous côté sud (côté lac), vers la porte du parking : la salle de convivialité est sur votre droite (C 04 – 012). Code d\'accès requis — le même que les autres codes du campus.',
      en: 'Enter the Metio building and go down to floor -1. On -1, head towards the south / lake side, towards the parking door: the salle de convivialité is on your right (C 04 – 012). Access code required — the same as the other campus codes.',
    } },
];
export default FRIDGES;
